import React, { useMemo } from "react";

import { CustomerOrderResponse } from "../../generated/graphql";
import styles from "./style.module.scss";
import { LocalisedText } from "../../i18n";
import OrderProductItem from "./OrderProductItem";
import { getTotalPriceFromOrderItems, displayPrice } from "../../utils/price";

interface OrderDetailsProps {
  customerOrder: CustomerOrderResponse;
  showReconfirmNotice?: boolean;
}

const OrderDetails: React.FC<OrderDetailsProps> = (
  props: OrderDetailsProps
) => {
  const { customerOrder, showReconfirmNotice } = props;
  const totalPrice = useMemo(
    () => getTotalPriceFromOrderItems(customerOrder.order.items),
    [customerOrder.order.items]
  );

  return (
    <div className={styles.orderDetails}>
      {showReconfirmNotice && (
        <div className={styles.reconfirmNotice}>
          <LocalisedText id="view.orderDetails.reconfirmNotice" />
        </div>
      )}
      <div className={styles.itemList}>
        {customerOrder.order.items.map((item, index) => (
          <OrderProductItem item={item} key={index} />
        ))}
      </div>
      <div className={styles.totalPrice}>
        <div className={styles.totalPriceTitle}>
          <LocalisedText id="view.orderDetails.total" />
        </div>
        <div className={styles.totalPriceValue}>
          ${displayPrice(totalPrice)}
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
